<div class="cart-slide-area" [class.cart-slide-active]="cartSlide">
  <!-- Top Header -->
  <div class="cart-slide-top">
    <div class="top-header-row">
      <div class="header-title">
        <i class="fas fa-shopping-basket"></i>
        <span>Total Item ({{ carts.length | numMinDigit }})</span>
      </div>
      <button type="button" class="close-btn" (click)="onHideCart()" aria-label="Close Cart">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="free-delivery-banner" *ngIf="shippingCharge?.freeDeliveryAmount">
      <span>Shop ৳ {{ shippingCharge?.freeDeliveryAmount }} to Enjoy Free Delivery</span>
      <i class="fa-solid fa-motorcycle"></i>
    </div>
  </div>

  <!-- Main Scrollable Content -->
  <div class="cart-slide-main">
    <div class="cart-item-area">
      <!-- Minimum Order Warning -->
      <div class="worning" *ngIf="this.cartSubTotal && this.cartSubTotal < shippingCharge?.minimumOrderAmount">
        <div class="icon">
          <i class="fas fa-exclamation"></i>
        </div>
        <div class="massage-text">
          <p class="massage">Please order at least <b>{{ shippingCharge?.minimumOrderAmount }}</b>৳</p>
          <a href="/product-list" routerLink="/product-list" class="by-more">Buy more</a>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-cart-view" *ngIf="!carts || !carts.length">
        <i class="fa-solid fa-basket-shopping"></i>
        <p>Your cart is empty</p>
      </div>

      <!-- Cart Item Card -->
      <div class="cart-item" *ngFor="let data of carts; index as i">
        <div class="cart-img">
          <img [src]="data?.product?.images?.[0] ?? './assets/images/placeholder/test.png'" [alt]="data?.product?.name" />

          <h4 class="discount-data" *ngIf="data?.product?.discountAmount && data?.product?.discountType == 2">
            <span class="discount-off">{{ data?.product?.discountAmount }}৳ OFF</span>
          </h4>

          <h4 class="discount-data" *ngIf="data?.product?.discountAmount && data?.product?.discountType == 1">
            <span class="discount-off">{{ data?.product?.discountAmount }}% OFF</span>
          </h4>
        </div>

        <div class="cart-text">
          <div class="name-title">
            <h4 [title]="data?.product?.name">
              {{ data?.product?.name }}
              {{ data?.product?.milligram ? data?.product?.milligram : "" }}
            </h4>
            <button type="button" class="delete-item" (click)="onDeleteCartItem(data?._id, data?.product?._id, data.priceId)" title="Remove item">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div class="cart-item-info">
            <span class="unit-tag" *ngIf="data?.unit">({{ data?.unit }}) - ৳ {{ data?.product | price : "salePrice" }}</span>
            <span class="type-tag" *ngIf="data?.product?.type?.name || data?.product?.type">Type: {{ data?.product?.type?.name || data?.product?.type }}</span>
          </div>

          <div class="quantity-price">
            <div class="quantity">
              <button type="button" (click)="onDecrementQty($event, data?._id, i, cartInput)" aria-label="Decrease">
                <i class="fa fa-minus"></i>
              </button>
              <input type="text" [value]="data?.selectedQty" readonly #cartInput />
              <button type="button" (click)="onIncrementQty($event, data?._id, i)" aria-label="Increase">
                <i class="fa fa-plus"></i>
              </button>
            </div>

            <div class="price-box">
              <div class="price-old" *ngIf="data?.product?.discountAmount > 0">
                <del>৳{{ data?.product | price : "regularPrice" : data?.selectedQty }}</del>
              </div>
              <div class="price-current">
                <b>৳{{ data?.product | price : "salePrice" : data?.selectedQty }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bill Details & Discount Info -->
    <div class="cart-details" *ngIf="carts && carts.length">
      <div class="amount-area">
        <p><span>Subtotal</span><span>৳ {{ cartSubTotalWithoutDiscount | number: '2.2' }}</span></p>
        <p *ngIf="cartDiscountAmount > 0"><span>Product Discount</span><span class="font_discount">-৳ {{ cartDiscountAmount | number: '1.2' }}</span></p>
        <p class="total-amount">
          <span>Amount Payable</span><span>৳ {{ grandTotal | number: '2.2' }}</span>
        </p>
      </div>

      <div class="discount-area"
        [style.display]="(!(cartSubTotal < orderOffer?.amountOrderMinAmount) && !(cartSubTotal < orderOffer?.amount2OrderMinAmount) && !(cartSubTotal < orderOffer?.amount3OrderMinAmount) && !(cartSubTotal < orderOffer?.monthOrderValue)) ? 'none' : 'block'">

        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.amountOrderMinAmount">
          <p>
            <strong>Get {{ orderOffer?.amountOrderDiscountAmount }}{{ orderOffer?.amountOrderDiscountType === 1 ? '%' : '৳' }}: </strong>
            <span>For purchasing above ৳ {{ orderOffer?.amountOrderMinAmount }} +</span>
          </p>
        </div>

        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.amount2OrderMinAmount">
          <p>
            <strong>Get {{ orderOffer?.amount2OrderDiscountAmount }}{{ orderOffer?.amount2OrderDiscountType === 1 ? '%' : '৳' }}: </strong>
            <span>For purchasing above ৳ {{ orderOffer?.amount2OrderMinAmount }} +</span>
          </p>
        </div>

        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.amount3OrderMinAmount">
          <p>
            <strong>Get {{ orderOffer?.amount3OrderDiscountAmount }}{{ orderOffer?.amount3OrderDiscountType === 1 ? '%' : '৳' }}: </strong>
            <span>For purchasing above ৳ {{ orderOffer?.amount3OrderMinAmount }} +</span>
          </p>
        </div>
        <div class="discount-area-content" *ngIf="cartSubTotal < orderOffer?.monthOrderValue">
          <p>
            <strong>Get {{ orderOffer?.monthOrderDiscountAmount }}{{ orderOffer?.monthOrderDiscountType === 1 ? '%' : '৳' }}: </strong>
            <span>For purchasing above ৳ {{ orderOffer?.monthOrderValue }} +</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Checkout Button -->
  <div class="cart-slide-bottom" *ngIf="carts && carts.length">
    <button type="button" class="checkout-btn" (click)="cartToOrderCart()">
      <p>Proceed To Checkout</p>
      <span>৳{{ grandTotal | number: '2.2' }}</span>
    </button>
  </div>
</div>

<!-- Backdrop Overlay -->
<div class="overlay" (click)="onHideCart()" [class.active]="cartSlide"></div>